namespace TabAurous.Finance {
    export namespace PartyBalanceService {
        export const baseUrl = 'Finance/PartyBalance';

        export declare function Create(request: Serenity.SaveRequest<PartyBalanceRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Update(request: Serenity.SaveRequest<PartyBalanceRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Delete(request: Serenity.DeleteRequest, onSuccess?: (response: Serenity.DeleteResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Retrieve(request: Serenity.RetrieveRequest, onSuccess?: (response: Serenity.RetrieveResponse<PartyBalanceRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function List(request: Serenity.ListRequest, onSuccess?: (response: Serenity.ListResponse<PartyBalanceRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function GetPartyBalance(request: TransactionRequest, onSuccess?: (response: Serenity.ListResponse<PartyBalanceRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function CustomerBalanceList(request: TransactionRequest, onSuccess?: (response: Serenity.ListResponse<PartyBalanceRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function CustomListForEdit(request: Serenity.ListRequest, onSuccess?: (response: Serenity.ListResponse<PartyBalanceRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function ValidatePartyBalance(request: TransactionRequest, onSuccess?: (response: Serenity.RetrieveResponse<PartyBalanceRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            Create = "Finance/PartyBalance/Create",
            Update = "Finance/PartyBalance/Update",
            Delete = "Finance/PartyBalance/Delete",
            Retrieve = "Finance/PartyBalance/Retrieve",
            List = "Finance/PartyBalance/List",
            GetPartyBalance = "Finance/PartyBalance/GetPartyBalance",
            CustomerBalanceList = "Finance/PartyBalance/CustomerBalanceList",
            CustomListForEdit = "Finance/PartyBalance/CustomListForEdit",
            ValidatePartyBalance = "Finance/PartyBalance/ValidatePartyBalance"
        }

        [
            'Create', 
            'Update', 
            'Delete', 
            'Retrieve', 
            'List', 
            'GetPartyBalance', 
            'CustomerBalanceList', 
            'CustomListForEdit', 
            'ValidatePartyBalance'
        ].forEach(x => {
            (<any>PartyBalanceService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
